import { ScrollTrigger } from "gsap/ScrollTrigger";
/**
 * Adds a class to elements when they enter the viewport
 * @param {string} selector - CSS selector for target elements
 * @param {string} className - Class to add (default: "isVisible")
 * @param {string} start - ScrollTrigger start position (default: "top 80%")
 */
const addVisibleOnScroll = (
	selector,
	className = "isVisible",
	start = "top 90%",
	end = "bottom 10%"
) => {
	document.querySelectorAll(selector).forEach((element) => {
		ScrollTrigger.create({
			trigger: element,
			start: start,
			end: end,
			onEnter: () => element.classList.add(className),
			onLeaveBack: () => element.classList.remove(className),
		});
	});
};

export default addVisibleOnScroll;
